export default __webpack_public_path__ + "static/heroSectionImage-ef9df549591eaaf4774bb9f7f3b5f0dd.webp";